import { createFileRoute } from "@tanstack/react-router";
import { NodeDetail } from "../../../features/infrastructure/nodes";

export const Route = createFileRoute("/_authed/$org/infrastructure/nodes/$name")({ component: Page });

function Page() {
  const { org, name } = Route.useParams();
  return <NodeDetail org={org} name={name} />;
}
